if (!window.StudentCertification) {
    window.StudentCertification = class {
        constructor(sectionId, shopName, couponRuleId) {
            this.shopName = shopName;
            this.couponRuleId = couponRuleId;
            // Moved off donumpro.com 2026-08-26: that domain expired 2026-07-25 and went
            // NXDOMAIN, so every request threw and the form always ended on "Network error".
            // Same server (18.117.87.141), same routes, its own Let's Encrypt cert, and CORS
            // already allows https://www.linsoul.com.
            this.baseUrl = 'https://studentapi.cyt.group/api/studentCertification';
            // this.baseUrl = 'http://localhost:8080/studentCertification';
            this.accept = '';
            this.maxFileSizeMB = 10;
            this.maxFileSize = 1024 * 1024 * this.maxFileSizeMB;
            this.IDCardFiles = [];
            this.isResubmit = false;
            const idStr = 'student-certification-' + sectionId;
            this.section = document.getElementById(idStr);
            this.form = this.section.querySelector('.student-certification__form');
            this.fileInput = this.section.querySelector('.student-certification__file-input');
        }


        /**
         * 添加文件选择事件并预览所选媒体文件
         */
        fileChange() {
            this.fileInput.addEventListener('change', (e) => {
                const fileNode = this.form.querySelector('.student-certification__errors-studentIDCard')
                const selectedFiles = e.target.files;
                if (selectedFiles.length === 0) return;
                const imageFiles = Array.from(selectedFiles);
                const allowedTypes = ['image/jpeg','image/jpg','image/png','image/gif','image/bmp','image/webp', 'application/pdf']
                let typeError = false;
                for (let i = 0; i < imageFiles.length; i++) {
                    const file = imageFiles[i];
                    if (!allowedTypes.includes(file.type)) {
                        typeError = true;
                        break;
                    }
                }

                if (typeError) {
                    fileNode.textContent = 'Only JPG, PNG, GIF and PDF files are allowed.';
                    return;
                } else {
                    fileNode.textContent = '';
                }
                this.IDCardFiles = imageFiles;
                this.previewMedia(imageFiles);
            });
        }


        /**
         * 根据传入的媒体文件数组，渲染预览文件
         * @param {Array} images
         * @returns
         */
        previewMedia(images=[]) {
            const filePreview = this.section.querySelector('.student-certification__file-preview');

            filePreview.innerHTML = ''; // 清空预览容器

            for (let i = 0; i < images.length; i++) {
                const file = images[i];
                const wrapper = this.createPreviewItem(i);

                const img = document.createElement('img');
                img.src = URL.createObjectURL(file);
                img.classList.add('preview-image');

                wrapper.appendChild(img);
                filePreview.appendChild(wrapper);
            }


        }

        /**
         * 创建单个预览文件
         * @param {number} index 用于删除预览文件
         */
        createPreviewItem(index) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('preview-item');
            wrapper.setAttribute('data-index', index + '');
            wrapper.setAttribute('data-type', 'image');

            const deleteBtn = document.createElement('span');
            deleteBtn.classList.add('preview-delete-btn');
            deleteBtn.innerHTML = '&#10006;';
            deleteBtn.addEventListener('click', () => {
                this.handleDeleteItem(wrapper);
            });

            wrapper.appendChild(deleteBtn);

            return wrapper;
        }

        /**
         * 删除单个预览对象并全部更新预览
         * @param {HTMLElement} item 预览对象的DOM元素
         */
        handleDeleteItem(item) {
            this.fileInput.value = '';
            item.remove(); // 删除预览项
        }

        handleFormFields() {

            const formData = new FormData(this.form);

            const customerId = formData.get('customerId');
            const email = formData.get('email').trim();
            const first_name = formData.get('first_name').trim();
            const last_name = formData.get('last_name').trim();
            const country = formData.get('country').trim();
            const school = formData.get('school').trim();
            const degree = formData.get('degree');
            const educationEmail = formData.get('educationEmail').trim();

            const emailNode = this.form.querySelector('.student-certification__errors-email');
            const passwordNode = this.form.querySelector('.student-certification__errors-password');
            const first_nameNode = this.form.querySelector('.student-certification__errors-first_name');
            const last_nameNode = this.form.querySelector('.student-certification__errors-last_name');
            const countryNode = this.form.querySelector('.student-certification__errors-country');
            const schoolNode = this.form.querySelector('.student-certification__errors-school');
            const fileNode = this.form.querySelector('.student-certification__errors-studentIDCard')
            const educationEmailNode = this.form.querySelector('.student-certification__errors-education-email')


            if (!email) {
                emailNode.textContent = 'Please enter your email';
                return null;
            } else {
                emailNode.textContent = '';
            }
            if (!this.validateEmail(email)){
                emailNode.textContent = 'Please enter correct email';
                return null;
            } else {
                emailNode.textContent = '';
            }

            let password = '';
            if (passwordNode) {
                password = formData.get('password').trim();
                if (!password) {
                    passwordNode.textContent = 'Please enter your password';
                    return null;
                } else {
                    passwordNode.textContent = '';
                }
                if (password.length < 6) {
                    passwordNode.textContent = 'Password must be at least 6 characters';
                    return null;
                } else {
                    passwordNode.textContent = '';
                }
            }

            if (!first_name) {
                first_nameNode.textContent = 'Please enter your first name';
                return null;
            } else {
                first_nameNode.textContent = '';
            }

            if (!last_name) {
                last_nameNode.textContent = 'Please enter your last name';
                return null;
            } else {
                last_nameNode.textContent = '';
            }

            if (!country) {
                countryNode.textContent = 'Please enter your country';
                return null;
            } else {
                countryNode.textContent = '';
            }
            if (!this.validateString(country)) {
                countryNode.textContent = 'Please enter correct country';
                return null;
            } else {
                countryNode.textContent = '';
            }

            if (!school) {
                schoolNode.textContent = 'Please enter your school name';
                return null;
            } else {
                schoolNode.textContent = '';
            }
            if (!this.validateString(school)){
                schoolNode.textContent = 'Please enter correct school name';
                return null;
            } else {
                schoolNode.textContent = '';
            }

            if (educationEmail) {
                if (!this.validateEmail(educationEmail)) {
                    educationEmailNode.textContent = 'Please enter correct email';
                    return null;
                } else {
                    educationEmailNode.textContent = '';
                }
            }
            if (!this.IDCardFiles.length && !educationEmail) {
                fileNode.textContent = 'Please upload at least one image or enter your education email';
                return null;
            } else {
                fileNode.textContent = '';
            }
            return {
                customerId,
                email,
                password,
                first_name,
                last_name,
                country,
                school,
                degree,
                educationEmail,
                IDCardFiles: this.IDCardFiles
            };
        }

        async handleImages(files) {
            const imagesForm = new FormData();
            files.forEach(file => {
                imagesForm.append('images', file);
            });

            try {
                return await this.uploadMedia(imagesForm)
            } catch (error) {
                return null;
            }

        }
        /**
         * 提交认证信息
         */
        handleSubmit() {
            this.form.addEventListener('submit', async (e) => {
                e.preventDefault();
                const formFields = this.handleFormFields();
                if (!formFields) return;
                const {
                    customerId,
                    email,
                    password,
                    first_name,
                    last_name,
                    country,
                    school,
                    degree,
                    educationEmail,
                    IDCardFiles
                } = formFields;
                let shopifyCustomer = null, imgUrls=[];

                this.changeSubmitBtnState(true);
                const filesIsUrl = IDCardFiles.find(file => typeof file === 'string');
                if(IDCardFiles.length && !filesIsUrl) {
                    imgUrls = await this.handleImages(IDCardFiles);
                    if (!imgUrls.length) {
                        alert('Network error, please try again later.');
                        return;
                    }
                }


                // 未登录，则创建shopify用户
                if (!customerId) {
                    const {data, status} = await this.createShopifyCustomer({
                        email,
                        password,
                        degree,
                        first_name,
                        last_name,
                        school,
                        country,
                    });
                    if (status === 300) {
                          if (confirm('You are already a customer of the store, please log in first.') === true) {
                            document.getElementById('goToLogin').click();
                        } else {
                            this.changeSubmitBtnState(false);
                        }
                        return;
                    }else if (status === 500) {
                        alert('Network error, please try again later.');
                        return;
                    } else {
                        shopifyCustomer = data;
                    }
                } else {

                    const {data, status} = await this.getShopifyCustomer(customerId);
                    if (status !== 500) {
                        shopifyCustomer = data;
                    } else {
                        alert('Network error, please try again later.');
                        return;
                    }
                }
                try {
                    let params = {
                        userId: Number(customerId) || Number(shopifyCustomer['_id']) || Number(shopifyCustomer['id']),
                        country,
                        school,
                        degree,
                        imgUrls: filesIsUrl ? IDCardFiles : imgUrls,
                        email,
                        first_name,
                        last_name,
                        couponRuleId: Number(this.couponRuleId),
                        educationEmail
                    }
                    if (this.isResubmit) {
                        params.statusCode = 0;
                    }
                    const addRes = await this.addStudent(params);
                    if (addRes.status !== 500) {
                        document.getElementById('goToThanksPage').click();
                    } else {
                        alert('Network error, please try again later.');
                        return false;
                    }
                } catch (error) {
                    alert('Network error, please try again later.');
                }
                this.changeSubmitBtnState(false);

               

            });
        }
        async addStudent(options) {
            try{
                return await fetch(this.baseUrl + '/addStudent/' + this.shopName, {
                    method: "POST",
                    headers: { "Content-Type": "application/json"},
                    body: JSON.stringify(options),
                }).then(response => response.json());
            } catch(e) {
                console.error('add student error:', e);
                return false;
            }
        }
        async createShopifyCustomer(data) {
            try{
                return await fetch(this.baseUrl + '/createShopifyCustomer/' + this.shopName, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data),
                }).then(response => response.json());
            } catch(e) {
                console.error('create customer error:', e);
                return false;
            }
        }
        validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
        validateString(str) {
            // 验证输入值长度是否大于1位
            if (str.length < 2) {
                return false;
            }

            // 验证输入值是否包含特殊字符
            const specialChars = /[!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]+/;
            return !specialChars.test(str);
        }

        async getShopifyCustomer(customerId) {
            try{
                return await fetch(this.baseUrl + '/getShopifyCustomer/' + this.shopName + '?customerId=' + customerId).then(response => response.json());

            } catch(e) {
                console.log({e})
                console.error('get customer error');
                return false;
            }
        }
        /**
         * 设置提交按钮的状态
         * @param {boolean} disabled
         */
        changeSubmitBtnState(disabled = false) {
            const submitBtn = this.section.querySelector('.student-certification__submit');
            if (disabled) {
                submitBtn.setAttribute('data-loading', 'true');
                submitBtn.setAttribute('disabled', 'disabled');
            } else {
                submitBtn.removeAttribute('data-loading');
                submitBtn.removeAttribute('disabled');
            }

        }

        /**
         * 根据类型通过formData形式将媒体文件上传到服务器
         * @param {FormData} formData
         * @returns
         */
        async uploadMedia(formData){
            try{
                const data = await fetch(this.baseUrl + '/upload', {
                    method: "POST",
                    body: formData,
                }).then(response => response.json());

                return data.urls;
            } catch(e) {
                console.error('Please upload at least one image');
                return false;
            }
        }
        patchFormByUrlSearchFields() {
            const url = location.href;
            const queryString = url.split('?')[1];
            const paramsObject = this._queryStringToObject(queryString);
            if (!paramsObject.userId) return;
            this.isResubmit = true;
            const {country, school, degree, email, first_name, last_name, educationEmail, userId, imgUrls} = paramsObject;

            this.form.querySelector('.auth-tips') && this.form.querySelector('.auth-tips').remove();
            this.form.querySelector('.student-certification__form-item.password') && this.form.querySelector('.student-certification__form-item.password').remove();

            this.form.querySelector('input[name="customerId"]').value = userId;
            this.form.querySelector('input[name="email"]').value = email;
            this.form.querySelector('input[name="first_name"]').value = first_name;
            this.form.querySelector('input[name="last_name"]').value = last_name;
            this.form.querySelector('input[name="educationEmail"]').value = educationEmail;
            this.form.querySelector('input[name="country"]').value = country;
            this.form.querySelector('input[name="school"]').value = school;
            this.form.querySelector('select[name="degree"]').value = degree;
            if (imgUrls) {
                this.IDCardFiles = imgUrls.split(',');
                this.form.querySelector('.student-certification__file-preview').innerHTML = `
                <div class="preview-item" data-index="0" data-type="image">
                    <span class="preview-delete-btn">✖</span>
                    <img src="${imgUrls}" class="preview-image">
                </div>
                `;
                document.querySelector('.preview-delete-btn').addEventListener('click', () => {
                    this.handleDeleteItem(document.querySelector('.preview-item'));
                });
            }

     
        }
        _queryStringToObject(queryString) {
            const params = new URLSearchParams(queryString);
            const obj = {};
            for (const pair of params.entries()) {
                const key = pair[0];
                const value = pair[1];
                // 处理重复键
                if (obj[key]) {
                    if (!Array.isArray(obj[key])) {
                        obj[key] = [obj[key]];
                    }
                    obj[key].push(value);
                } else {
                    obj[key] = value;
                }
            }
            return obj;
        }
        _clearForm() {
            this.form.querySelectorAll('input').forEach(node => {
                node.value = '';
            });
            this.form.querySelector('select').value = 'High School';
            this.form.querySelector('.student-certification__file-preview').innerHTML = '';
        }
        async init(){
            this.patchFormByUrlSearchFields();
            this.fileChange();
            this.handleSubmit();
        }
    }
}


// window.onload = function () {
    const studentCertification = document.querySelectorAll('[data-section-type="studentCertification"]');
    studentCertification.forEach((item, index) => {
        const sectionId = item.getAttribute('data-section-id').trim();
        const shopName = item.getAttribute('data-shop-name').trim();
        const couponRuleId = item.getAttribute('data-coupon-rule-id').trim();

        new StudentCertification(sectionId, shopName, couponRuleId).init().then();
    });

// }